import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const policyDetailsSlice = createApi({
    reducerPath: "policyDetails",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://policy-parsing.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        policyDetails: builder.query({
            query: (data) => ({ url: "/policy-inward/api/v1/policy/detail", params: data, method: "GET" }),
        }),
    }),
});

export const { usePolicyDetailsQuery } = policyDetailsSlice;
